import react from "react";
import '../css/Common.css'
const Terms = () => {
    return (
        <div className="page-container">
            <h1>Terms & Conditions</h1>
            <p>By using this platform, you agree to the following terms:</p>
            <ul>
                <li>You will not misuse the platform.</li>
                <li>You will provide accurate information.</li>
                <li>We are not responsible for delays in issue resolution.</li>
            </ul>
        </div>
    );
};
export default Terms;